export enum MetricTimeSpan {
    OneHour,
    ThreeHours,
    SixHours,
    TwelveHours,
    TwentyFourHours
}
